import { createWebHistory, createRouter } from 'vue-router';
import { useQuasar } from 'quasar';
import { GlobalStore } from '@/store';
import { AuthStore } from '@/store/modules/auth';
import { staticRouter, errorRouter } from './modules/staticRouter';
import { initDynamicRouter } from './modules/dynamicRouter';
import { duplicatedGrowthplateLogin, logoutMacadamia, requestGrowthplateLogout } from '@/helpers/common';

const router = createRouter({
    // history: createWebHashHistory(),
    history: createWebHistory(),
    routes: [...staticRouter, ...errorRouter],
    strict: false,
    scrollBehavior: () => ({ left: 0, top: 0 }),
});

router.beforeEach(async (to, from, next) => {
    const gStore = GlobalStore();
    // console.log('--beforeEach-from-', from.path);
    // console.log('--beforeEach-to-', to.path);

    if (to.path === '/login') {
        if (gStore.token) return router.push('/learninghome');
    }

    if (to.path === '/eval-test') {
        if (!gStore.token_eval) {
            if (gStore.is_member_eval) return router.push('/eval-member');
            else return router.push('/eval-login');
        }
    }

    const curUrl = [
        'learninghome',
        'note',
        'incorrectnote',
        'killernote',
        'analysisreport',
        'dailyreport',
        'satreport',
        'corereading',
        'authenticreading',
        'vocabularylearning',
        'sat',
        'mypage',
        'userinfo',
        'inform',
        'settings',
        'map',
        'faq',
        'eval-member',
    ].find((e) => to.path === '/' + e);
    if (curUrl) {
        console.log('curUrl ===', curUrl);
        if (!gStore.token || gStore.isUserFirstLogin || gStore.isUserPwReset || gStore.isUserPwExpired) {
            // url접속차단, 신규비번 변경체크
            const loginRoot = gStore.loginRoot;
            if (loginRoot === 'web' || loginRoot === 'external-login') {
                //토큰정보 삭제
                gStore.initStore();
            }
            if (loginRoot === 'growthplate') {
                requestGrowthplateLogout();
            } else if (loginRoot === 'macadamia') {
                window.location.href = process.env.VUE_APP_SSO_LOGIN_URL;
            } else if (loginRoot == 'web') {
                window.location.href = '/exp-login';
            } else {
                window.location.href = '/krt-login';
            }
        }
    }

    if (to.path === '/report/review') return next();
    // if (!globalStore.token) return next({ path: '/login', replace: true });
    const authStore = AuthStore();
    if (!authStore.menuListGet.length) {
        await initDynamicRouter();
        authStore.menuMeta = authStore.menuList.filter((i) => (i.path = to.path)).pop();
        return next({ ...to, replace: true });
    } else {
        authStore.menuMeta = authStore.menuList.filter((i) => (i.path = to.path)).pop();
        next();
    }
});

router.afterEach(() => {});

router.onError((error) => {
    // console.log(error);
});

export default router;
